import VueRouter from 'vue-router';

let routes = [

    {
        path: '/albuns/:album_id/:album_name',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/albuns/:album_id/:album_name/produto/:produto/:id',
        component: ()=>import('./ExternalCatalog/product-view.vue')
    },

    {
        path: '/albuns/:album_id/:album_name/orcar',
        component: ()=>import('./ExternalCatalog/cart.vue'),
    },

    {
        path: '/albuns/:album_id/:album_name/pesquisa',
        component: ()=>import('./ExternalCatalog/search-results.vue'),
    },

    {
        path: '/albuns/:album_id/:album_name/:category/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/albuns/:album_id/:album_name/:category/:subcategory/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/albuns/:album_id/:album_name/:category/:subcategory/:subcategory2/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/albuns/:album_id/:album_name/:category/:subcategory/:subcategory2/:subcategory3/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/albuns/:album_id/:album_name/:category/:subcategory/:subcategory2/:subcategory3/:subcategory4/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/catalogo',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
        alias: '/',
    },

    {
        path: '/catalogo/destaques',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/catalogo/arquiteto/:architect/:office_id',
        component: ()=>import('./ExternalCatalog/architect.vue'),
    },

    {
        path: '/catalogo/arquiteto/:architect/:office_id/:category/:id',
        component: ()=>import('./ExternalCatalog/architect.vue'),
    },

    {
        path: '/catalogo/arquiteto/:architect/:office_id/:category/:subcategory/:id',
        component: ()=>import('./ExternalCatalog/architect.vue'),
    },

    {
        path: '/catalogo/arquiteto/:architect/:office_id/:category/:subcategory/:subcategory2/:id',
        component: ()=>import('./ExternalCatalog/architect.vue'),
    },

    {
        path: '/catalogo/arquiteto/:architect/:office_id/:category/:subcategory/:subcategory2/:subcategory3/:id',
        component: ()=>import('./ExternalCatalog/architect.vue'),
    },

    {
        path: '/catalogo/arquiteto/:architect/:office_id/:category/:subcategory/:subcategory2/:subcategory3/:subcategory4/:id',
        component: ()=>import('./ExternalCatalog/architect.vue'),
    },

    {
        path: '/catalogo/consultor/:consultant/:consultant_id',
        component: ()=>import('./ExternalCatalog/consultant.vue'),
    },

    {
        path: '/catalogo/consultor/:consultant/:consultant_id/:category/:id',
        component: ()=>import('./ExternalCatalog/consultant.vue'),
    },

    {
        path: '/catalogo/consultor/:consultant/:consultant_id/:category/:subcategory/:id',
        component: ()=>import('./ExternalCatalog/consultant.vue'),
    },

    {
        path: '/catalogo/consultor/:consultant/:consultant_id/:category/:subcategory/:subcategory2/:id',
        component: ()=>import('./ExternalCatalog/consultant.vue'),
    },

    {
        path: '/catalogo/consultor/:consultant/:consultant_id/:category/:subcategory/:subcategory2/:subcategory3/:id',
        component: ()=>import('./ExternalCatalog/consultant.vue'),
    },

    {
        path: '/catalogo/consultor/:consultant/:consultant_id/:category/:subcategory/:subcategory2/:subcategory3/:subcategory4/:id',
        component: ()=>import('./ExternalCatalog/consultant.vue'),
    },

    {
        path: '/projetos',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/solicitar-convite',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/catalogo/projeto/:project/:id',
        component: ()=>import('./ExternalCatalog/project-view.vue'),
    },

    {
        path: '/projetos/:category/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/projetos/:category/:subcategory/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/projetos/:category/:subcategory/:subcategory2/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/projetos/:category/:subcategory/:subcategory2/:subcategory3/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/projetos/:category/:subcategory/:subcategory2/:subcategory3/:subcategory4/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/arquitetos',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/consultores',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/catalogo/orcar',
        component: ()=>import('./ExternalCatalog/cart.vue'),
    },

    {
        path: '/catalogo/pesquisa',
        component: ()=>import('./ExternalCatalog/search-results.vue'),
    },

    {
        path: '/catalogo/produto/:produto/:id',
        component: ()=>import('./ExternalCatalog/product-view.vue')
    },

    {
        path: '/catalogo/:category/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/catalogo/:category/:subcategory/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/catalogo/:category/:subcategory/:subcategory2/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/catalogo/:category/:subcategory/:subcategory2/:subcategory3/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/catalogo/:category/:subcategory/:subcategory2/:subcategory3/:subcategory4/:id',
        component: ()=>import('./ExternalCatalog/catalog.vue'),
    },

    {
        path: '/contato',
        component: ()=>import('./ExternalCatalog/contact-us.vue'),
    },

    {
        path: '/home',
        component: ()=>import('./ExternalCatalog/custom-home.vue'),
    },

    {
        path: '/:404',
        component: ()=>import('./ExternalCatalog/404.vue')
    },

];

export default new VueRouter({

	routes, 
	linkActiveClass: "''",
    linkExactActiveClass: "active"

});